import { Box, Typography } from '@mui/material';
import type { ComponentType, ReactNode } from 'react';

interface ScopeGateProps {
  Icon: ComponentType<{ sx?: object }>;
  title: string;
  description: ReactNode;
  /** Picker / action controls rendered under the copy. */
  children?: ReactNode;
}

/**
 * The panel shown instead of a page when the current scope can't support it —
 * no centre exists yet, or the top bar is on the read-only "All Centres" rollup.
 * Purely presentational; the routing guards (CentreRequiredRoute,
 * SingleCentreRoute) decide when it appears.
 */
export const ScopeGate = ({ Icon, title, description, children }: ScopeGateProps) => (
  <Box
    sx={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
      gap: '14px', maxWidth: 460, mx: 'auto',
      px: { xs: '16px', sm: '24px' }, py: { xs: '48px', md: '80px' },
    }}
  >
    <Box
      sx={(theme) => ({
        width: 48, height: 48, borderRadius: '50%', display: 'flex',
        alignItems: 'center', justifyContent: 'center', bgcolor: theme.palette.status.info.bg,
      })}
    >
      <Icon sx={{ fontSize: 24, color: 'primary.main' }} />
    </Box>

    <Typography sx={(theme) => ({ fontSize: { xs: 17, md: 18 }, fontWeight: 700, color: theme.palette.grey[900] })}>
      {title}
    </Typography>
    <Typography sx={(theme) => ({ fontSize: 13.5, color: theme.palette.grey[500] })}>
      {description}
    </Typography>

    {children}
  </Box>
);
